
export default {
  name: 'PercentageCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What is percent in math?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "In math, percent represents a fraction after multiplying by 100 and adding a percent sign (%) next to the result. For example, if you get 85 questions correct out of 100 on the test, which equates to 85/100, you've completed 85% correctly."
        }
      },{
        "@type": "Question",
        "name": "What can I calculate with a percentage calculator?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The percentage calculator allows users to quickly and accurately process values in different situations and fields. It mainly provides quick support for calculations such as chemical reactions, physics, cost of sales, income tax, inflation rate, and purchase discount. In short, this tool supports determining the percentage for any number."
        }
      },{
        "@type": "Question",
        "name": "Is the percentage difference equal to the percentage change calculator?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The short answer is no. Percentage difference and percentage change calculator are entirely different concepts. The reference point in the percentage difference calculation is usually the average or the midpoint of two numbers. In contrast, percentage change uses 1 of the two numbers to be calculated as reference percentage points. Finally, the percentage change calculator is a directional comparison, while the percentage difference formula is not."
        }
      },{
        "@type": "Question",
        "name": "How do you find 70 percent of a number?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To find 70% of a number, multiply that number by 70. Then divide the result by 100 to get the final answer."
        }
      },{
        "@type": "Question",
        "name": "What is the average raise percentage change for 2022?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "In about ten years, from 2002 to 2022, the basic salary paid to employees tends to increase by 3%. In fact, in May 2022, this number rose to 4.8% (according to the survey results of Pearl Meyer)."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      loading: false,
      form: this.$vform({
        percentage: null,
        percentageOf: null,
        percentageResult: null,
        percentageIs: null,
        percentageWhat: null,
        percentageWhatResult: null,
        isPercentage: null,
        isPercentageOf: null,
        isPercentageOfResult: null
      })
    }
  },
  methods: {
    onPercentageCalculator() {
        this.form.percentageResult = this.form.percentage * this.form.percentageOf / 100;
    },
    onPercentageWhatCalculator(){
        this.form.percentageWhatResult = this.form.percentageIs / this.form.percentageWhat * 100 + '%';
    },
    onIsPercentageOfCalculator(){
        this.form.isPercentageOfResult = this.form.isPercentage / this.form.isPercentageOf * 100;
    }
  }
}
